<template>
  <div>
    <v-container fluid pa-0>
      <!-- Quienes Somos -->
      <v-layout row wrap align-center id="quienes_somos">
        <v-flex xs12 sm5 md5 lg4 offset-xs2 offset-sm1 offset-md1 offset-lg2 px-12>
          <hr class="line">
          <p class="display-1 font-weight-bold py-3">WHO WE ARE</p>
          <p class="font-weight-light">PROA, with 20 years of experience in the door and hardware industry, offers solutions from design advisory and specification until installation, and start for its projects</p>
        </v-flex>
        <v-flex xs12 md6>
          <v-img width="100%" height="100%" transition="scale-transition" src="../assets/home_quienes-somos.png"></v-img>
        </v-flex>
      </v-layout>

      <!-- Mision / Vision -->
      <v-layout row wrap style="background-color: #f05f32" white--text text-center py-12>
        <v-flex xs12 sm5 offset-sm1 px-12>
          <h1 class="display-1 font-weight-bold py-3">MISSION</h1>
          <p class="font-weight-light">Change the paradigm of how the client perceives security solutions, efficiency and protection, proving added value of this integration.</p>
        </v-flex>
        <v-flex xs12 sm5 px-12>
          <h1 class="display-1 font-weight-bold py-3">VISION</h1>
          <p class="font-weight-light">Make the world a better and more secure place, creating, designing, habilitating, and operating solutions of security and efficiency, integrating new technologies.</p>
        </v-flex>
      </v-layout>

      <!-- Conoce Nuestro Equipo -->
      <v-layout row wrap style="background-color: #303336" white--text>
        <v-flex xs12 md7 pa-12>
          <span class="font-italic font-weight-medium">TEAM PROA</span>
          <h1>GET TO KNOW OUR TEAM</h1>
          <v-flex xs1 pb-4>
            <hr style="border-color: #f05f32">
          </v-flex>
          <v-flex>
            <iframe width="100%" height="500" src="https://www.youtube.com/embed/eXWSDiPjwaA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><br>
          </v-flex>
          <v-flex>
            <p class="font-weight-light">Happiness makes people apply their efforts based on a common vision. In PROA, we are working at keeping our talent focused and motivated, helping them achieve their professional purpose, accomplishing that with the help of our experts we make the world a more efficient and safer place.</p>
          </v-flex>
        </v-flex>
        <v-flex v-if="windowSize < 2" xs12>
          <v-img width="100%" src="../assets/side_nuestro-equipo2.png"></v-img>
        </v-flex>
        <v-flex v-else xs12 md5>
          <v-img min-height="100%" width="100%" class="img__Rectangle" src="../assets/side_nuestro-equipo.png"></v-img>
        </v-flex>
      </v-layout>

      <!-- Productos -->
      <v-layout row wrap text-center justify-center pr-12>
        <v-flex xs12 pl-12 pt-8 text-left>
          <h1>SOLUTIONS</h1>
          <v-flex xs6 sm2 md1 pb-4 pr-12>
            <hr style="border-color: #f05f32">
          </v-flex>
        </v-flex>
        <v-flex
          xs12 sm6 md4 lg3 px-12 py-4
          v-for="product in solucionesProduct"
          :key="product.text"
        >
          <div class="flip-container" ontouchstart="this.classList.toggle('hover')">
            <div class="flipper">
              <div class="front">
                <v-img height="100%" width="100%" :src="product.img">
                  <v-layout align-end justify-end fill-height text-center>
                    <v-flex white--text py-2 style="background-color: rgba(46, 49, 49, 0.6)">
                      <h4>{{ product.text }}</h4>
                    </v-flex>
                  </v-layout>
                </v-img>
              </div>
              <div class="back">
                <v-img height="100%" :src="product.img" gradient="to top left, rgba(46, 49, 49, 0.6), rgba(46, 49, 49, 0.6)">
                  <v-layout row wrap align-end justify-end fill-height text-center>
                    <v-flex xs12 text-left px-8 white--text>
                      <ul>
                        <li
                          v-for="item in product.list"
                          :key="item"
                          class="py-1 text-uppercase"
                        ><b>{{ item }}</b></li>
                      </ul>
                    </v-flex>
                    <v-flex white--text py-2 style="background-color: rgba(46, 49, 49, 0.6)">
                      <h4>{{ product.text }}</h4>
                    </v-flex>
                  </v-layout>
                </v-img>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>

      <!-- Certificaciones -->
      <v-layout row wrap style="background-color: #FAFAFA">
        <v-flex xs12 pl-12 pt-8>
          <h1>CERTIFICATIONS</h1>
          <v-flex xs6 sm2 md1 pb-4 pr-12>
            <hr style="border-color: #f05f32">
          </v-flex>
        </v-flex>
      </v-layout>
      <div v-if="windowSize >= 2" class="px-12" style="background-color: #FAFAFA">
        <hooper
          :itemsToShow="4"
          :itemsToSlide="4"
          :centerMode="false"
          :playSpeed="3000"
          :transition="800"
          :hoverPause="false"
          :wheelControl="false"
          pagination="no"
          autoPlay
          infiniteScroll
        >
          <slide v-for="(slide, index) in certifications" :key="index" :index="index">
            <img width="50%" :src="slide.src"/>
          </slide>
        </hooper>
      </div>
      <div v-else style="background-color: #FAFAFA">
        <hooper
          :itemsToShow="2"
          :itemsToSlide="2"
          :centerMode="false"
          :playSpeed="3000"
          :transition="800"
          :hoverPause="false"
          :wheelControl="false"
          pagination="no"
          autoPlay
          infiniteScroll
        >
          <slide v-for="(slide, index) in certifications" :key="index" :index="index">
            <img width="80%" :src="slide.src"/>
          </slide>
        </hooper>
      </div>

      <!-- Verticales -->
      <v-layout v-if="windowSize > 2" row wrap style="background-color: #4e5257">
        <v-flex xs12 pl-12 pt-8 white--text>
          <h1>VERTICALS</h1>
          <v-flex xs6 sm2 md1 pr-12>
            <hr style="border-color: #f05f32">
          </v-flex>
        </v-flex>
      </v-layout>
      <div v-if="windowSize > 2" class="py-4 px-12" style="background-color: #4e5257">
        <dashboard :id="'dashExample'">
          <dash-layout v-for="layout in dlayouts" v-bind="layout" :debug="false" :key="layout.breakpoint">
            <dash-item v-for="item in layout.items" v-bind.sync="item" :key="item.id">
              <v-card tile flat hover class="content" @click="goLink(item.link)">
                <v-img
                  height="100%"
                  :src="item.src"
                  :gradient="item.hover ? 'to top left, rgba(46, 49, 49, 0.6), rgba(46, 49, 49, 0.6)' : 'to top right, rgba(0,0,0,0.0), rgba(0,0,0,0.0)'"
                  @mouseover="item.hover = true"
                  @mouseleave="item.hover = false"
                >
                  <v-layout align-end justify-end fill-height>
                    <v-flex text-right white--text pr-6 py-2 :style="!item.hover ? 'background-color: rgba(46, 49, 49, 0.6)' : ''">
                      <h2>{{ item.title }}<v-icon dark large>arrow_forward</v-icon></h2>
                    </v-flex>
                  </v-layout>
                </v-img>
              </v-card>
            </dash-item>
          </dash-layout>
        </dashboard>
      </div>

      <!-- Nuestros Clientes -->
      <v-layout row wrap style="background-color: #FAFAFA">
        <v-flex xs8 md11 pl-12 pt-8>
          <h1>OUR CLIENTS</h1>
          <v-flex xs6 sm2 md1 pb-8 pr-12>
            <hr style="border-color: #f05f32">
          </v-flex>
        </v-flex>
      </v-layout>
      <div v-if="windowSize >= 2" class="px-12" style="background-color: #FAFAFA">
        <hooper
          :itemsToShow="4"
          :itemsToSlide="4"
          :centerMode="false"
          :playSpeed="3000"
          :transition="800"
          :hoverPause="false"
          :wheelControl="false"
          pagination="no"
          autoPlay
          infiniteScroll
        >
          <slide v-for="(slide, index) in clients" :key="index" :index="index">
            <img width="50%" :src="slide.src"/>
          </slide>
        </hooper>
      </div>
      <div v-else style="background-color: #FAFAFA">
        <hooper
          :itemsToShow="2"
          :itemsToSlide="2"
          :centerMode="false"
          :playSpeed="3000"
          :transition="800"
          :hoverPause="false"
          :wheelControl="false"
          pagination="no"
          autoPlay
          infiniteScroll
        >
          <slide v-for="(slide, index) in clients" :key="index" :index="index">
            <img width="80%" :src="slide.src"/>
          </slide>
        </hooper>
      </div>

      <!-- Contact -->
      <v-layout row wrap pa-8 text-center white--text id="contacto" class="contact" style="background-color: #2a2d30">
        <v-flex xs12>
          <h1>CONTACT</h1>
        </v-flex>
        <v-flex xs12 md6 px-8>
          <v-form v-model="form">
            <v-layout row wrap pa-8 text-center>
              <v-flex xs12>
                <v-text-field
                  v-model="mail.company"
                  :rules="[() => mail.company.length >= 1 || 'Invalid name']"
                  label="Company name"
                  solo
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="mail.telefono"
                  :rules="[() => mail.telefono.length >= 1 || 'Invalid phone']"
                  label="Phone"
                  solo
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="mail.email"
                  :rules="[rules.email]"
                  label="Email"
                  solo
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="mail.mercado"
                  :items="mercadoVertical"
                  label="Vertical Market"
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="mail.solucion"
                  :items="soluciones"
                  label="Solutions"
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="mail.message"
                  :rules="[() => mail.message.length >= 1 || 'Invalid message']"
                  label="Project details"
                  solo
                  required
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-btn block color="#f05f32" :class="{'disable-events' : !form}" :loading="loading" dark @click="sendEmail">Send</v-btn>
              </v-flex>
              <v-flex v-if="responseMessage" xs12 pt-4>
                <h3 style="color: #FCB713">{{ responseMessage }}</h3>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
        <v-flex xs12 md6 pt-12>
          <div class="text pt-12"><b>CONTACT:</b></div>
          <div class="text">+52 81 8040 8510</div><br><br><br><br>

          <div class="text"><b>EMAIL:</b></div>
          <a href="mailto:contact@proainternational.com?" class="text" style="text-decoration: none; color: white;">contact@proainternational.com</a>
          <v-flex xs4 offset-xs4 pb-8>
            <hr style="border-color: #f05f32">
          </v-flex>
        </v-flex>
      </v-layout>

      <!-- Sucursales -->
      <v-layout row wrap style="background-color: #f15f32" pa-12 white--text>
        <v-flex xs12 pl-12>
          <h1>BRANCHES</h1>
          <v-flex xs6 sm2 md1 pb-12 pr-12>
            <hr style="border-color: white">
          </v-flex>
        </v-flex>
        <v-flex xs12 sm6 md3 pl-12 pb-10>
          <h3>MONTERREY:</h3>
          <div class="font-weight-light">Blvd. Antonio L. Rodríguez #2100</div>
          <div class="font-weight-light">Torre BH - Piso 15 COL. SANTA MARIA</div>
          <div class="font-weight-light">MONTERREY, N.L. CP 64650</div>
        </v-flex>
        <v-flex xs12 sm6 md3 pl-12>
          <h3>MEXICO:</h3>
          <div class="font-weight-light">AV. COLONIA DEL VALLE #737 ALTOS</div>
          <div class="font-weight-light">COL. DEL VALLE DELEGACIÓN</div>
          <div class="font-weight-light">BENITO JUAREZ, MÉXICO D.F. CP 03100</div>
        </v-flex>
        <v-flex xs12 sm6 md3 pl-12>
          <h3>QUERETARO:</h3>
          <div class="font-weight-light">CALZADA RUFINO TAMAYO #41</div>
          <div class="font-weight-light">FRACC. PUEBLO NUEVO</div>
          <div class="font-weight-light">CORREGIDORA QUERÉTARO CP 76190</div>
        </v-flex>
        <v-flex xs12 sm6 md3 pl-12>
          <h3>COSTA RICA:</h3>
          <div class="font-weight-light">CURRIBADAT, SAN JOSE COSTA RICA 500</div>
          <div class="font-weight-light">MTS NORTE DE LA PLAZA GUAYABOS</div>
          <div class="font-weight-light">OFICENTRO RGA, 2DO PISO</div>
        </v-flex>
      </v-layout>

      <!-- Map -->
      <div>
        <google-map/>
      </div>
    </v-container>
  </div>
</template>

<script>
import GoogleMap from '../components/GoogleMap'
import { Dashboard, DashLayout, DashItem } from 'vue-responsive-dash'
import { Hooper, Slide } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: 'home',
  components: {
    GoogleMap,
    Dashboard,
    DashLayout,
    DashItem,
    Hooper,
    Slide
  },
  data: () => ({
    loading: false,
    responseMessage: '',
    done: false,
    form: false,
    mercadoVertical: ['Hospital', 'Education', 'Hotels', 'High Security', 'Review Curriculum'],
    soluciones: ['Metallic and Wooden Doors', 'Anden Equipment'],
    mail: {
      company: '',
      telefono: '',
      email: '',
      message: '',
      mercado: '',
      solucion: ''
    },
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid email'
      }
    },
    solucionesProduct: [
      {
        text: 'WOODEN DOORS',
        img: require('../assets/Productos/madera.png'),
        list: ['Doors with Natural Wood Plate', 'Doors with Composite Wood Plate', 'Laminated Plastic Doors', 'Melamin/Vynil Doors', 'Painted Doors with Solid Finish', 'Fiber Glass Doors']
      },
      {
        text: 'METAL DOORS',
        img: require('../assets/Productos/metal.png'),
        list: ['Pedestrian Metallic Doors', 'Emergency Exit Doors', 'Fireproof Metallic Doors', 'Acoustic Metallic Doors', 'Armored Metallic Doores', 'Explosion proof Metallic Doors']
      },
      {
        text: 'AUTOMATIC DOORS',
        img: require('../assets/Productos/automaticas.png'),
        list: ['Sliding Automatic Door', 'Revolving Automatic Door', 'Folding Autmatic Door', 'Telescopic Automatic Door']
      },
      {
        text: 'SPECIAL DOORS',
        img: require('../assets/Productos/especiales.png'),
        list: ['Industrial Doors', 'Refrigeration Doors', 'Alimentary Grade Door']
      },
      {
        text: 'METALLIC ROLL-UP DOORS',
        img: require('../assets/Productos/enrolladas.png'),
        list: ['Roll-up Service Curtains', 'Insulated Roll-up Curtains', 'Fireproof Roll-up Curtains', 'Counter Roll-up Cutrains', 'Grilles Roll-up Curtains']
      },
      {
        text: 'FAST CURTAINS',
        img: require('../assets/Productos/rapidas.png'),
        list: ['Fast Curtains for Interiors', 'Work Fast Curtains', 'Security Fast Curtains', 'Fast Curtains for Clean Rooms', 'Fast Curtains for Cold Rooms']
      },
      {
        text: 'SECTIONABLE DOORS',
        img: require('../assets/Productos/seccionales.png'),
        list: ['Non-Insulated Sectional Metallic Door', 'Insulated Sectional Metallic Door', 'Aluminum Sectionsl Doors', 'Impact Sectional Doors']
      },
      {
        text: 'ANDEN EQUIPMENT',
        img: require('../assets/Productos/anden_puerta.png'),
        list: ['Mechanical Leveling Ramp', 'Hydraulic Leveling Ramp', 'Air Leveling Ramp', 'Vertial Leveling Ramp', 'Anden Edge Ramp', 'Mechanical Lock']
      }
    ],
    certifications: [
      { src: require('../assets/Certificaciones/ansi.png') },
      { src: require('../assets/Certificaciones/bhma.png') },
      { src: require('../assets/Certificaciones/dhi.png') },
      { src: require('../assets/Certificaciones/fsc.png') },
      { src: require('../assets/Certificaciones/intertek.png') },
      { src: require('../assets/Certificaciones/nfpa.png') },
      { src: require('../assets/Certificaciones/ul.png') },
      { src: require('../assets/Certificaciones/usgbc.png') }
    ],
    clients: [
      { src: require('../assets/Clientes/amazon.png') },
      { src: require('../assets/Clientes/arca-continental.png') },
      { src: require('../assets/Clientes/audi.png') },
      { src: require('../assets/Clientes/BBVA.png') },
      { src: require('../assets/Clientes/denso.png') },
      { src: require('../assets/Clientes/GM.png') },
      { src: require('../assets/Clientes/hampton.png') },
      { src: require('../assets/Clientes/intel.png') },
      { src: require('../assets/Clientes/pepsi.png') },
      { src: require('../assets/Clientes/st_joseph.png') }
    ],
    dlayouts: [
      {
        breakpoint: 'xl',
        numberOfCols: 10,
        items: [
          { id: '1', x: 0, y: 0, width: 3, height: 1.5, draggable: false, hover: false },
          { id: '2', x: 3, y: 0, width: 3, height: 1.5, draggable: false, hover: false },
          { id: '3', x: 6, y: 0, width: 4, height: 1, draggable: false, hover: false },
          { id: '4', x: 0, y: 1.5, width: 3, height: 1.5, draggable: false, hover: false },
          { id: '5', x: 3, y: 1.5, width: 3, height: 2, draggable: false, hover: false },
          { id: '6', x: 6, y: 1, width: 2, height: 2, draggable: false, hover: false },
          { id: '7', x: 8, y: 1, width: 2, height: 2, draggable: false, hover: false },
          { id: '8', x: 0, y: 3, width: 3, height: 1.5, draggable: false, hover: false },
          { id: '9', x: 3, y: 3.5, width: 3, height: 1, draggable: false, hover: false },
          { id: '10', x: 6, y: 3, width: 4, height: 1.5, draggable: false, hover: false }
        ]
      },
      {
        breakpoint: 'lg',
        breakpointWidth: 1200,
        numberOfCols: 10,
        items: [
          { id: '1', x: 0, y: 0, width: 3, height: 1.5, draggable: false, hover: false, title: 'GOVERNMENT', src: require('../assets/Collage/gobierno_senado.jpg'), link: 'government' },
          { id: '2', x: 3, y: 0, width: 3, height: 1.5, draggable: false, hover: false, title: 'COMERCIAL', src: require('../assets/Collage/pabellon_comercial.jpg'), link: 'comercial' },
          { id: '3', x: 6, y: 0, width: 4, height: 1, draggable: false, hover: false, title: 'EDUCATION', src: require('../assets/Collage/itesm_educacion.jpg'), link: 'education' },
          { id: '4', x: 0, y: 1.5, width: 3, height: 1.5, draggable: false, hover: false, title: 'HOSPITAL', src: require('../assets/Collage/hospitalario_puerta-de-hierro.jpg'), link: 'hospital' },
          { id: '5', x: 3, y: 1.5, width: 3, height: 2, draggable: false, hover: false, title: 'HOTEL', src: require('../assets/Collage/hoteleria_cityexpress.jpg'), link: 'hotel' },
          { id: '6', x: 6, y: 1, width: 2, height: 2, draggable: false, hover: false, title: 'CORPORATIVE', src: require('../assets/Collage/corporativo_downtownSF.jpg'), link: 'corporative' },
          { id: '7', x: 8, y: 1, width: 2, height: 2, draggable: false, hover: false, title: 'RESIDENTIAL', src: require('../assets/Collage/residencial_santafe.jpg'), link: 'residential' },
          { id: '8', x: 0, y: 3, width: 3, height: 1.5, draggable: false, hover: false, title: 'PENITENTIARY', src: require('../assets/Collage/penitenciaria_guanajuato.jpg'), link: 'penitentiary' },
          { id: '9', x: 3, y: 3.5, width: 3, height: 1, draggable: false, hover: false, title: 'INDUSTRIAL', src: require('../assets/Collage/industrial_audi.jpg'), link: 'industrial' },
          { id: '10', x: 6, y: 3, width: 4, height: 1.5, draggable: false, hover: false, title: 'ENTERTAINMENT CENTER', src: require('../assets/Collage/Estadio_BBVA_Bancomer_-_Diciembre_2017.jpg'), link: 'entertainment' }
        ]
      },
      {
        breakpoint: 'md',
        breakpointWidth: 996,
        numberOfCols: 8,
        items: [
          { id: '1', x: 0, y: 0, width: 3, height: 1.5, draggable: false, hover: false },
          { id: '2', x: 3, y: 0, width: 3, height: 1.5, draggable: false, hover: false },
          { id: '3', x: 6, y: 0, width: 2, height: 1, draggable: false, hover: false },
          { id: '4', x: 0, y: 1.5, width: 3, height: 2, draggable: false, hover: false },
          { id: '5', x: 3, y: 1.5, width: 3, height: 2, draggable: false, hover: false },
          { id: '6', x: 6, y: 1, width: 2, height: 2.5, draggable: false, hover: false }
        ]
      },
      {
        breakpoint: 'sm',
        breakpointWidth: 768,
        numberOfCols: 2,
        items: [
          { id: '1', x: 0, y: 0, width: 2, height: 1.5, draggable: false, hover: false }
        ]
      },
      {
        breakpoint: 'xs',
        breakpointWidth: 480,
        numberOfCols: 2,
        items: [
          { id: '1', x: 0, y: 0, width: 2, height: 1, draggable: false, hover: false }
        ]
      },
      {
        breakpoint: 'xxs',
        breakpointWidth: 0,
        numberOfCols: 1,
        items: [
          { id: '1', x: 0, y: 0, width: 1, height: 1, draggable: false, hover: false }
        ]
      }
    ]
  }),
  computed: {
    windowSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 0
        case 'sm': return 1
        case 'md': return 2
        case 'lg': return 3
        case 'xl': return 4
        default: return 0
      }
    }
  },
  methods: {
    sendEmail () {
      this.loading = true
      var emailjs = window.emailjs
      emailjs.send('default_service', 'template_tI9e37dJ_clone', this.mail).then(response => {
        console.log('Success!', response.status, response.text)
        this.loading = false
        this.responseMessage = 'Message successfully sent!'
        this.mail = {}
      }, error => {
        console.log('Failed...', error)
        this.loading = false
        this.responseMessage = 'Error, try sending the message again.'
      })
    },
    goLink (vertical) {
      var link = {
        text: 'VERTICALS',
        to: '/verticales/' + vertical,
        image: 'header_hoteleria.png',
        selected: false
      }
      this.$emit('goLink', link)
    }
  }
}
</script>

<style>
html, body {
  overflow-x: hidden;
}
body {
  position: relative
}
p {
  text-align: justify;
  text-align-last: left;
}
.line {
  position: relative;
  width: 13%;
  border-width: 0.1em;
  top: 2em;
  right: 4.5em;
  border-color: #f05f32;
  z-index: 0;
}
.img__Rectangle {
  height: 100px;
  width: 50px;
  background-color: #303336;
  z-index: 0;
}
.content {
  height: 100%;
  width: 100%;
  color: white;
}
.contact {
  background-image: url('../assets/hoteleria_contacto.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
.disable-events {
  pointer-events: none
}
.text {
  font-size: 180%
}
/* entire container, keeps perspective */
.flip-container {
  perspective: 1000px;
}
  /* flip the pane when hovered */
  .flip-container:hover .flipper, .flip-container.hover .flipper {
    transform: rotateY(180deg);
  }
.flip-container, .front, .back {
  width: 320px;
  height: 380px;
}
/* flip speed goes here */
.flipper {
  transition: 0.6s;
  transform-style: preserve-3d;
  position: relative;
}
/* hide back of pane during swap */
.front, .back {
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
}
/* front pane, placed above back */
.front {
  z-index: 2;
  /* for firefox 31 */
  transform: rotateY(0deg);
}
/* back, initially hidden pane */
.back {
  transform: rotateY(180deg);
  background: rgb(170, 170, 170);
}
</style>
